export default "__VITE_ASSET__DtpM646R__"